import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogOverlay,
  Box,
  Button,
  Flex,
  Text,
  useToast,
} from "@chakra-ui/react";
import { useRef } from "react";

import { ReactComponent as ConfirmIcon } from "src/assets/icon/confirm-icon.svg";
import { useDeleteWebhookMutation } from "src/hook/webhook/webhook";
interface Props {
  idWebhook: string | undefined;
  isOpen: boolean;
  onClose: () => void;
  setOpenSuccess: () => void;
}

const ConfirmDeletWebhookComponent = (props: Props) => {
  const { isOpen, onClose, idWebhook, setOpenSuccess } = props;
  const [deleteWebhook, { isLoading }] = useDeleteWebhookMutation();
  const toast = useToast();

  const cancelRef = useRef();

  const submitDelete = () => {
    if (idWebhook) {
      deleteWebhook(idWebhook)
        .unwrap()
        .then(() => {
          setOpenSuccess();
        })
        .catch(() => {
          toast({
            title: "Delete Webhook.",
            description: "Delete webhook failed",
            status: "error",
            duration: 2000,
            isClosable: true,
            position: "top",
          });
        });
    }
    onClose();
  };

  return (
    <>
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef as any}
        onClose={onClose}
      >
        <AlertDialogOverlay bg={"#052A6E"} opacity={"0.7 !important"} />
        <AlertDialogContent
          minW={"42%"}
          color={"#171E38"}
          bg={"#F2F5FC"}
          top={"50%"}
          transform={"translateY(-50%) !important"}
          m={0}
        >
          <AlertDialogCloseButton
            _focusVisible={{
              outline: "none",
              border: "none",
            }}
            size={"lg"}
          />
          <AlertDialogBody p={"40px"} textAlign={"center"}>
            <Box display={"flex"} justifyContent={"center"} mb={"10px"}>
              <ConfirmIcon stroke={"#E54E43"} />
            </Box>
            <Text
              fontSize={"40px"}
              fontFamily={"Avenir Black"}
              lineHeight={"55px"}
            >
              Confirm deletion
            </Text>
            <Flex flexDir={"column"} justifyContent="center">
              <Text fontSize={"18px"} fontFamily={"Avenir Medium"}>
                Are you sure you want to delete this Webhook?
              </Text>
              <Text fontSize={"18px"} fontFamily={"Avenir Medium"} mb={"24px"}>
                Data will be stopped sending to this URL immediately.
              </Text>
            </Flex>
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
              fontFamily={"Avenir Black"}
            >
              <Button
                variant={"solid"}
                bg={"#E74D3D"}
                w={"65%"}
                height={"54px"}
                borderRadius={"37px"}
                color={"#FFFFFF"}
                fontSize={"20px"}
                isLoading={isLoading}
                disabled={isLoading}
                _hover={{
                  bg: "#E74D3D",
                  opacity: 0.8,
                }}
                onClick={submitDelete}
              >
                Delete
              </Button>
            </Box>
          </AlertDialogBody>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};

export default ConfirmDeletWebhookComponent;
